import React from 'react';
import './Preisberechnung.css';
import Kulissenpreis from "./Kulissenpreis";
import ZusatzoptionenPreis from "./ZusatzoptionenPreis";
import {
    calculateGesamtpreisNettoNachRabatt,
    calculatePreisVorRabatt,
    calculateSchalldaempferGehaeuseflaeche,
} from "../calculations/pricing";

class Preisberechnung extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      kulissenpreis: 0,
      preisZusatzoptionenKulisse:0,
    };
    this.handleKulissenpreisChange = this.handleKulissenpreisChange.bind(this);
    this.handlePreisZusatzoptionenKulisseChange = this.handlePreisZusatzoptionenKulisseChange.bind(this);
  }
    handleKulissenpreisChange(value){
      if(value !== this.state.kulissenpreis){
          this.setState({kulissenpreis:value})
      }
    }
    handlePreisZusatzoptionenKulisseChange(value){
        if(value !== this.state.preisZusatzoptionenKulisse){
            this.setState({preisZusatzoptionenKulisse:value})
        }
    }

    preisberechnung(){
        let kulissenpreis = this.state.kulissenpreis;
        let zusatzoptionenKulisse = this.state.preisZusatzoptionenKulisse;

        let preis = calculateGesamtpreisNettoNachRabatt({
            Schalldaempferlaenge: this.props.Schalldaempferlaenge,
            Schalldaempferhoehe: this.props.Schalldaempferhoehe,
            Schalldaempferbreite: this.props.Schalldaempferbreite,
            AnzahlKulissen: this.props.AnzahlKulissen,
            Rabatt: this.props.Rabatt,
            kulissenpreis,
            preisZusatzoptionenKulisse: zusatzoptionenKulisse,
        });

        this.props.PreisChange(preis);
        return preis;


    }
    gesamtpreis_Schalldaempfer(kanalpreis, kulissenpreis,  anzahlKulissen){
        return calculatePreisVorRabatt({ kanalpreis, kulissenpreis, anzahlKulissen });
    }

    preisKanal(kanalflaeche){
        //Kanalflaeche * 13€
        return kanalflaeche * 40;
    }

    // getEQMBP(druckbereich, kanalbreite, kanalhoehe, kanallaenge){
    //     //Preisberechnung von Herrn Schweich für Schalldaempfergehäuse
    //
    //     switch (druckbereich) {
    //         case "ND":
    //             if(kanallaenge <900){
    //                 // console.log("Preis: Druckbereich " + druckbereich + " kanallaenge < 900: " + kanallaenge);
    //                 if(kanalbreite <= 250 || kanalhoehe <= 250){
    //                     // console.log("Preis: Druckbereich " + druckbereich + " kanalbreite <= 250: " + kanalbreite + " || kanalhohe <=250 "+ kanalhoehe);
    //                     return 134;
    //                 }
    //                 else if( (kanalbreite > 250 && kanalbreite <2000) && (kanalhoehe > 250 && kanalhoehe <2000) ){
    //                     // console.log("Preis: Druckbereich " + druckbereich + " kanalbreite > 250 && <2000: " + kanalbreite + " && kanalhohe >250 <2000 "+ kanalhoehe);
    //                     return 124;
    //                 }
    //                 else if(kanalbreite >= 2000 || kanalhoehe >= 2000){
    //                     // console.log("Preis: Druckbereich " + druckbereich + " kanalbreite >= 2000: " + kanalbreite + " || kanalhohe >=2000 "+ kanalhoehe);
    //                     return 145;
    //                 }
    //
    //             }
    //             else if(kanallaenge >=900){
    //                 console.log("Preis: Druckbereich " + druckbereich + " kanallaenge >= 900: " + kanallaenge);
    //                 if(kanalbreite <= 250 || kanalhoehe <= 250){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite <= 250: " + kanalbreite + " || kanalhohe <=250 "+ kanalhoehe);
    //                     return 112;
    //                 }
    //                 else if( (kanalbreite > 250 && kanalbreite <2000) && (kanalhoehe > 250 && kanalhoehe <2000) ){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite > 250 && <2000: " + kanalbreite + " && kanalhohe >250 <2000 "+ kanalhoehe);
    //                     return 103;
    //                 }
    //                 else if(kanalbreite >= 2000 || kanalhoehe >= 2000){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite >= 2000: " + kanalbreite + " || kanalhohe >=2000 "+ kanalhoehe);
    //                     return 140;
    //                 }
    //             }
    //             break;
    //         case "MD":
    //             if(kanallaenge <900){
    //                 console.log("Preis: Druckbereich " + druckbereich + " kanallaenge < 900: " + kanallaenge);
    //                 if(kanalbreite <= 250 || kanalhoehe <= 250){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite <= 250: " + kanalbreite + " || kanalhohe <=250 "+ kanalhoehe);
    //                     return 134;
    //                 }
    //                 else if( (kanalbreite > 250 && kanalbreite <2000) && (kanalhoehe > 250 && kanalhoehe <2000) ){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite > 250 && <2000: " + kanalbreite + " && kanalhohe >250 <2000 "+ kanalhoehe);
    //                     return 124;
    //                 }
    //                 else if(kanalbreite >= 2000 || kanalhoehe >= 2000){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite >= 2000: " + kanalbreite + " || kanalhohe >=2000 "+ kanalhoehe);
    //                     return 145;
    //                 }
    //
    //             }
    //             else if(kanallaenge >=900){
    //                 console.log("Preis: Druckbereich " + druckbereich + " kanallaenge >= 900: " + kanallaenge);
    //                 if(kanalbreite <= 250 || kanalhoehe <= 250){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite <= 250: " + kanalbreite + " || kanalhohe <=250 "+ kanalhoehe);
    //                     return 112;
    //                 }
    //                 else if( (kanalbreite > 250 && kanalbreite <2000) && (kanalhoehe > 250 && kanalhoehe <2000) ){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite > 250 && <2000: " + kanalbreite + " && kanalhohe >250 <2000 "+ kanalhoehe);
    //                     return 103;
    //                 }
    //                 else if(kanalbreite >= 2000 || kanalhoehe >= 2000){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite >= 2000: " + kanalbreite + " || kanalhohe >=2000 "+ kanalhoehe);
    //                     return 140;
    //                 }
    //             }
    //             break;
    //             case "HD":
    //             if(kanallaenge <900){
    //                 console.log("Preis: Druckbereich " + druckbereich + " kanallaenge < 900: " + kanallaenge);
    //                 if(kanalbreite < 500 || kanalhoehe < 500){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite < 500: " + kanalbreite + " || kanalhohe <500 "+ kanalhoehe);
    //                     return 341;
    //                 }
    //                 else if( (kanalbreite >= 500 && kanalbreite <2000) && (kanalhoehe >= 500 && kanalhoehe <2000) ){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite >= 500 && <2000: " + kanalbreite + " && kanalhohe >=500 <2000 "+ kanalhoehe);
    //                     return 283;
    //                 }
    //                 else if(kanalbreite >= 2000 || kanalhoehe >= 2000){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite >= 2000: " + kanalbreite + " || kanalhohe >=2000 "+ kanalhoehe);
    //                     return 379;
    //                 }
    //
    //             }
    //             else if(kanallaenge >=900){
    //                 console.log("Preis: Druckbereich " + druckbereich + " kanallaenge >= 900: " + kanallaenge);
    //                 if(kanalbreite <= 250 || kanalhoehe <= 250){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite <= 250: " + kanalbreite + " || kanalhohe <=250 "+ kanalhoehe);
    //                     return 278;
    //                 }
    //                 else if( (kanalbreite > 250 && kanalbreite <2000) && (kanalhoehe > 250 && kanalhoehe <2000) ){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite > 250 && <2000: " + kanalbreite + " && kanalhohe >250 <2000 "+ kanalhoehe);
    //                     return 232;
    //                 }
    //                 else if(kanalbreite >= 2000 || kanalhoehe >= 2000){
    //                     console.log("Preis: Druckbereich " + druckbereich + " kanalbreite >= 2000: " + kanalbreite + " || kanalhohe >=2000 "+ kanalhoehe);
    //                     return 320;
    //                 }
    //             }
    //             break;
    //
    //
    //     }
    // }

    getFlaeche(kanallaenge,kanalhoehe,kanalbreite){
        return calculateSchalldaempferGehaeuseflaeche({
            Schalldaempferlaenge: kanallaenge,
            Schalldaempferhoehe: kanalhoehe,
            Schalldaempferbreite: kanalbreite,
        });
    }

  render() {
       // let test =  <Kulissenpreis Kulissenbreite={this.props.Kulissenbreite} Kulissenhoehe={this.props.Schalldaempferhoehe} Kulissenlaenge={this.props.Schalldaempferlaenge} Kulissentyp={this.props.Kulissentyp} KulissenpreisChange={this.handleKulissenpreisChange}/>

      this.preisberechnung().toFixed(2)

      // console.log("PreisPreis " + preis)
            return (
                <>
                    <Kulissenpreis Kulissenbreite={this.props.Kulissenbreite}
                                   Kulissenhoehe={this.props.Schalldaempferhoehe}
                                   Kulissenlaenge={this.props.Schalldaempferlaenge} Kulissentyp={this.props.Kulissentyp}
                                   KulissenpreisChange={this.handleKulissenpreisChange}
                                   Optionen={this.props.Optionen}
                    />
                    <ZusatzoptionenPreis Kulissenbreite={this.props.Kulissenbreite}
                                         Kulissenhoehe={this.props.Schalldaempferhoehe}
                                         Kulissenlaenge={this.props.Schalldaempferlaenge}
                                         Rabatt={this.props.Rabatt}
                                         KulissenpreisNetto={this.state.kulissenpreis}
                                         Optionen={this.props.Optionen}
                                         ZusatzoptionenpreisChange={this.handlePreisZusatzoptionenKulisseChange}
                    />

                    {/*{this.preisberechnung() > 0 ? this.preisberechnung().toFixed(2) : parseFloat('0')}*/}

                </>
            )
  }
}
export default Preisberechnung;
